import { createSelector } from 'reselect'

import addNewClientApi, { ClientRegistration } from './addNewClientApi'

export const selectClientRegistrationsResult = (providerId: string) =>
  addNewClientApi.endpoints.getClientRegistrations.select({ providerId })

export const selectClientRegistrations = (providerId: string) =>
  createSelector(selectClientRegistrationsResult(providerId), (result) => result?.data?.clients)

export const selectPendingRegistrations = (providerId: string) =>
  createSelector(selectClientRegistrations(providerId), (clients) =>
    clients?.filter((client: ClientRegistration) => client.registration_status === 'pending'),
  )

export const selectCompletedRegistrations = (providerId: string) =>
  createSelector(selectClientRegistrations(providerId), (clients) =>
    clients?.filter((client: ClientRegistration) => client.registration_status === 'completed'),
  )

export const selectClientRegistrationsLoading = (providerId: string) =>
  createSelector(selectClientRegistrationsResult(providerId), (result) => result?.isLoading)

export const selectExpiredRegistrations = (providerId: string) =>
  createSelector(selectClientRegistrations(providerId), (clients) =>
    clients?.filter((client: ClientRegistration) => client.registration_status === 'expired'),
  )

export const selectOutstandingRegistrations = (providerId: string) =>
  createSelector(selectClientRegistrations(providerId), (clients) =>
    clients?.filter((client: ClientRegistration) => client.registration_status !== 'completed'),
  )

export const selectClientRegistrationsError = (providerId: string) =>
  createSelector(selectClientRegistrationsResult(providerId), (result) => result?.error)
